import { DataStatus, DataStatusReviewer } from '../StudyList';

type Result = Record<
  DataStatusReviewer,
  Partial<Record<DataStatus['type'], DataStatus>>
>;

export const groupStatusByReviewer = (data: DataStatus[]): Result => {
  return data.reduce(
    (acc, status) => {
      const { reviewer, type } = status;
      const reviewerData = acc[reviewer];
      reviewerData[type] = status;

      return acc;
    },
    {
      reviewer1: {} as Record<DataStatus['type'], DataStatus>,
      reviewer2: {} as Record<DataStatus['type'], DataStatus>,
      consensus: {} as Record<DataStatus['type'], DataStatus>,
    }
  );
};
